// extracted by mini-css-extract-plugin
export var emailBlockLink = "_li-0";